var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllTask({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1 17.3989L34.4666 24.3655C33.0666 30.3822 30.3 32.8155 25.1 32.3155C24.2666 32.2489 23.3666 32.0989 22.4 31.8655L19.6 31.1989C12.65 29.5489 10.5 26.1155 12.1333 19.1489L13.7666 12.1655C14.1 10.7489 14.5 9.51554 15 8.49887C16.95 4.46554 20.2666 3.38221 25.8333 4.69887L28.6166 5.34887C35.6 6.98221 37.7333 10.4322 36.1 17.3989Z",
    stroke: "#595959",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1006 32.3147C24.0672 33.0147 22.7672 33.598 21.1839 34.1147L18.5506 34.9814C11.9339 37.1147 8.45057 35.3314 6.30057 28.7147L4.16724 22.1314C2.0339 15.5147 3.80057 12.0147 10.4172 9.88138L13.0506 9.01471C13.7339 8.79805 14.3839 8.61471 15.0006 8.49805C14.5006 9.51471 14.1006 10.748 13.7672 12.1647L12.1339 19.148C10.5006 26.1147 12.6506 29.548 19.6006 31.198L22.4006 31.8647C23.3672 32.098 24.2672 32.248 25.1006 32.3147Z",
    stroke: "#595959",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2524 11.9609L32.1519 13.8096",
    stroke: "#595959",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8657 17.1348L30.7652 18.9835",
    stroke: "#595959",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3867 22.6543C25.3502 23.4484 29.2875 24.5033 29.2875 24.5033",
    stroke: "#595959",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.836 11.0685L19.3708 11.9948L22.1497 10.3904M17.4658 16.1822L18.0006 17.1085L20.7794 15.5041M16.0956 21.2959L16.6304 22.2222L19.4092 20.6179",
    stroke: "#595959",
    strokeWidth: 0.952941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllTask);
export default __webpack_public_path__ + "static/media/AllTask.2d4959359008ae82a0993ed1b83fdde2.svg";
export { ForwardRef as ReactComponent };